import { Flow, Text } from 'bold-ui'
import { ReactNode } from 'react'

interface HistoricoMChatSimpleVerticalTableItemProps {
  pergunta: ReactNode | undefined
  resposta: string | undefined | null
}

export const HistoricoMChatSimpleVerticalTableItem = (props: Readonly<HistoricoMChatSimpleVerticalTableItemProps>) => {
  const { pergunta, resposta } = props

  if (pergunta === undefined) return null
  const hasResposta = resposta !== undefined && resposta !== null

  return (
    <Flow direction='vertical' gap={0} style={styles.item}>
      <Text heading={4} fontWeight='bold'>
        {pergunta}
      </Text>
      {hasResposta && <Text heading={4}>{resposta}</Text>}
    </Flow>
  )
}

const styles = {
  item: {
    alignItems: 'flex-start',
    width: '100%',
  },
}
